import React, { useState } from 'react';
import { ArrowUpRight, Weight } from 'lucide-react';
import { pates } from '../mock';
import FicheModal from './FicheModal';
import { useLang } from '../LanguageContext';
import { useTheme } from '../ThemeContext';

const Pates = () => {
  const [selected, setSelected] = useState(null);
  const { t, patesLoc } = useLang();
  const theme = useTheme();

  return (
    <section id="pates" className="bg-[#efe4cf] py-28 border-t border-[#0d1b36]/5">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-10 mb-20">
          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6">
              {t.pates.eyebrow}
            </p>
            <h2 className="font-serif text-5xl md:text-6xl text-[#0d1b36] leading-[1.08]">
              {t.pates.t1}<br />
              <em className="italic font-light">{t.pates.t2}</em>
            </h2>
          </div>
          <div className="md:col-span-2 md:pt-20">
            <p className="text-[#0d1b36]/70 text-base leading-relaxed">
              {t.pates.desc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
          {pates.map((item, idx) => (
            <button
              key={item.id}
              onClick={() => setSelected({ ...item, tag: patesLoc.tags[idx], subtitle: patesLoc.subs[idx] })}
              className={`group text-left cursor-pointer ${idx % 2 === 1 ? 'md:translate-y-10' : ''}`}
            >
              <div className="relative overflow-hidden rounded-xl aspect-[4/3] bg-white flex items-center justify-center p-4">
                <div
                  className="absolute top-4 left-4 z-10 px-3 py-1 rounded-full backdrop-blur text-[#f6ecd9] text-[9px] tracking-[0.25em] uppercase max-w-[65%] truncate"
                  style={{ background: theme.primary85 }}
                >
                  {patesLoc.tags[idx]}
                </div>
                <div className="absolute top-4 right-4 z-10 px-3 py-1 rounded-full bg-[#d4a94c] text-[#0d1b36] text-[10px] tracking-[0.2em] font-semibold">
                  {item.weight}
                </div>
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b36]/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <div className="flex items-start justify-between mt-5 gap-4">
                <div className="flex-1">
                  <h3 className="font-serif text-2xl text-[#0d1b36] mb-1 group-hover:text-[#d4a94c] transition-colors">
                    {item.name}
                  </h3>
                  <p className="text-[11px] tracking-[0.2em] uppercase text-[#0d1b36]/60 leading-relaxed">
                    {patesLoc.subs[idx]}
                  </p>
                </div>
                <span className="flex items-center gap-1 text-[#d4a94c] text-[10px] tracking-[0.3em] uppercase pt-1 group-hover:gap-2 transition-all shrink-0">
                  {t.pates.fiche}
                  <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={2} />
                </span>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-20 flex flex-wrap items-center justify-center gap-5">
          <div className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#0d1b36]/20 text-[#0d1b36]/70 text-[10px] tracking-[0.3em] uppercase">
            <Weight className="w-3.5 h-3.5 text-[#d4a94c]" strokeWidth={1.75} />
            {t.pates.atm}
          </div>
          <div className="px-5 py-2.5 rounded-full border border-[#0d1b36]/20 text-[#0d1b36]/70 text-[10px] tracking-[0.3em] uppercase">
            {t.pates.cold}
          </div>
        </div>
      </div>

      <FicheModal
        open={!!selected}
        onClose={() => setSelected(null)}
        item={selected}
        type="pate"
      />
    </section>
  );
};

export default Pates;
